import { isAstrum } from '@platform/shared';
import {
  ContactsPage,
  CalcPage,
  DocumentPage,
  MainPage,
} from '../views';

export default [
  {
    path: '/contacts',
    name: 'contacts-page',
    component: ContactsPage,
  },
  {
    path: '/calc',
    name: 'calc-page',
    component: CalcPage,
  },
  ...(document.domain === 'astrum-entertainment.ru' ? [{
    path: '/legal/:projectSlug/:documentSlug?/:contextSlug?',
    name: 'document-page',
    props: true,
    component: DocumentPage,
  }] : []),
  {
    path: '/:projectSlug/:documentSlug?/:contextSlug?',
    name: 'document-page',
    props: true,
    component: DocumentPage,
  },
  {
    path: '/',
    name: 'index',
    component: MainPage,
  },
];
